// 深拷贝
const deepClone = (obj) => {
  var o;
  // 如果  他是对象object的话  , 因为null,object,array  也是'object';
  if (typeof obj === 'object') {
    // 如果  他是空的话
    if (obj === null) {
      o = null;
    }
    else {
      // 如果  他是数组arr的话
      if (obj instanceof Array) {
        o = [];
        for (var i = 0, len = obj.length; i < len; i++) {
          o.push(deepClone(obj[ i ]));
        }
      }
      // 如果  他是对象object的话
      else {
        o = {};
        for (var j in obj) {
          o[ j ] = deepClone(obj[ j ]);
        }
      }
    }
  }
  else {
    o = obj;
  }
  return o;
};


  /**
 * 获取相对路径
 * @method getRelativePath
 * @return {*} 返回主机地址
 * @example http://172.19.82.130:8080/uploadfiles/summary/7c54efed-fbc0-49c0-8568-62b07b5c1816/temp/3.png
 */
let getRelativePath = url => {
  let str = url.split("http://")[1]; //172.19.82.130:8080/uploadfiles/summary/7c54efed-fbc0-49c0-8568-62b07b5c1816/temp/3.png
  if(str){
    let pos = str.indexOf("/"); //获取 相对路径 在 str 的索引号,如:18
    let relativePath = str.substring(pos + 1, url.length); //获取相对路径,如: uploadfiles/summary/7c54efed-fbc0-49c0-8568-62b07b5c1816/temp/3.png
    return relativePath;
  }
};
export {deepClone, getRelativePath };


// WEBPACK FOOTER //
// ./src/utils/utils.js